import React from 'react';
import { get, set } from 'lodash/fp';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FieldConf } from './creditApplicationFields';

const Toggle = require('react-bootstrap-toggle').default;

interface Props {
  label: string;
  id: string;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  creditFormConfig: any;
  allDependencyFields: FieldConf[];
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setCreditFormConfig: (newConf: any) => void;
  creditFormKey: string[];
  referencesEnabled?: boolean;
}

function getLogic(props: Props) {
  const dependenciesKey = props.creditFormKey.concat('dependencies').join('.');
  const mandatoryKey = props.creditFormKey.concat('mandatory').join('.');
  const selectedDependecyIds = get(dependenciesKey, props.creditFormConfig);
  return {
    setFieldMandatory(value: boolean): void {
      props.setCreditFormConfig(
        set(mandatoryKey, value, props.creditFormConfig),
      );
    },
    setDependencies(selected: FieldConf[]): void {
      const newConfig = set(
        dependenciesKey,
        selected.map(v => v.id),
        props.creditFormConfig,
      );
      props.setCreditFormConfig(newConfig);
    },
    isFieldMandatory: get(mandatoryKey, props.creditFormConfig) || false,
    selectedDependencies: props.allDependencyFields.filter(field =>
      selectedDependecyIds?.includes(field.id),
    ),
  };
}

export function CreditApplicantField(props: Props) {
  const logic = getLogic(props);
  const isReferenceField = props.id.startsWith('references');

  const handleToggleClick = () => {
    const newValue = !logic.isFieldMandatory; // Get the new value based on current state

    if (isReferenceField && !props.referencesEnabled && newValue) {
      // eslint-disable-next-line no-alert
      alert('Please enable Display References first');
      return;
    }
    logic.setFieldMandatory(newValue);
  };

  return (
    <tr key={props.id}>
      <td>{props.label}</td>
      <td>
        <Toggle
          on="Yes"
          off="No"
          size="sm"
          onClick={handleToggleClick}
          active={logic.isFieldMandatory}
        />
      </td>
      <td>
        <Typeahead
          id="category-typeahead"
          placeholder="None"
          selectHintOnEnter
          multiple
          clearButton
          labelKey="label"
          onChange={logic.setDependencies}
          options={props.allDependencyFields}
          selected={logic.selectedDependencies}
        />
      </td>
    </tr>
  );
}

export const test = {
  getLogic,
};
